// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../../types';

type Props = {
  selected: boolean,
};

export default styled<any, Theme, Props>('button')`
  &:focus {
    outline:0;
  }

  height: 1rem;
  width: 1rem;
  background-color: ${props => props.theme.slider.dot.unselected};
  border: none;
  border-radius: 50%;
  margin-left: .8rem;

  &:first-child {
    margin-left: 0;
  }

  ${props => (props.selected && css`
    background-color: ${props.theme.slider.dot.selected};
  `)}
`;
